export default __webpack_public_path__ + "static/img/chat-unlocked.58865d7.jpg";